import { reactive } from "vue";
import instance from "@/plugins/axios";
import lzstring from "lz-string";

// To avoid multiple shit
let isProcessing = false;

export const location = reactive({
  latitude: null,
  longitude: null,
  accuracy: null,
  error: null,
  isMocked: false
});

export const sendLocation = async () => {
  try {
    const response = await instance.post("/user/@me/telemetry", {
      latitude: location.latitude,
      longitude: location.longitude,
      accuracy: location.accuracy,
      isMocked: location.isMocked
    });
    return response;
  } catch (error) {
    console.error("Error sending location:", error);
    return null;
  }
};

export const saveLocations = async (locs) => {
  // console.log("Saving locations", locs);
  // return locs;
  return await instance.post("/user/@me/telemetry/bulk", locs).catch((error) => {
    console.error("Error saving locations:", error);
    return null;
  });
};

export const getLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        location.latitude = position.coords?.latitude;
        location.longitude = position.coords?.longitude;
        location.accuracy = position.coords?.accuracy;
        location.error = null;

        try {
          const mocked = window.NativeLocation?.isLocationMock() || false;
          location.isMocked = mocked;

          calculate(location.latitude, location.longitude, location.accuracy, location.isMocked);
          sendLocation();
        } catch (error) {
          console.error("Error getting mock location status:", error);
        }
      },
      (error) => {
        location.error = error.message;
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
    );
  }
};

// This is to watch the location changes continuously
export const watchLocation = () => {
  if (navigator.geolocation) {
    navigator.geolocation.watchPosition(
      (position) => {
        console.log("watching location", position);

        location.latitude = position.coords?.latitude;
        location.longitude = position.coords?.longitude;
        location.accuracy = position.coords?.accuracy;
        location.error = null;

        try {
          const mocked = window.NativeLocation?.isLocationMock() || false;
          location.isMocked = mocked;
          calculate(location.latitude, location.longitude, location.accuracy, location.isMocked);
          sendLocation();
        } catch (error) {
          console.error("Error getting mock location status:", error);
        }
      },
      (error) => {
        location.error = error.message;
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }
    );
  }
};

export const Haversine = (lat1, lon1, lat2, lon2) => {
  const R = 6371e3; // metres
  const w1 = (lat1 * Math.PI) / 180; // φ, λ in radians
  const w2 = (lat2 * Math.PI) / 180;
  const deltaw = ((lat2 - lat1) * Math.PI) / 180;
  const deltahlv = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(deltaw / 2) * Math.sin(deltaw / 2) +
    Math.cos(w1) * Math.cos(w2) * Math.sin(deltahlv / 2) * Math.sin(deltahlv / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = R * c; // in metres

  return d;
};

// This function calculates the distance between two geographical points and saves the location data in local storage. (To minimize API calls and Redundancy)
export const calculate = async (lat, long, accuracy, mocked) => {
  const currentTimestamp = new Date().valueOf();

  let x;
  try {
    x = JSON.parse(lzstring.decompressFromUTF16(window.localStorage.getItem("ky_currentLoc")) || "[]");
  } catch (e) {
    x = [];
  }
  // [{lt:lat,lg:long,ac:accuracy,start:currentTimestamp, end:currentTimestamp }...]
  if (x.length > 0) {
    const latest = x[x.length - 1];
    const distance = Haversine(lat, long, latest.lt, latest.lg);
    const timeDiff = currentTimestamp - latest.end;

    if (distance < 1 && timeDiff < 30000) {
      latest.end = currentTimestamp;
    } else {
      x.push({ lt: lat, lg: long, ac: accuracy, start: currentTimestamp, end: currentTimestamp, m: mocked });
    }
  } else {
    x.push({ lt: lat, lg: long, ac: accuracy, start: currentTimestamp, end: currentTimestamp, m: mocked });
  }

  if (x.length > 10) {
    await saveLocations(x).then(() => {
      x.splice(0, x.length);
    });
  }

  console.log("when saved", x);

  window.localStorage.setItem("ky_currentLoc", lzstring.compressToUTF16(JSON.stringify(x)));
};

window.addEventListener("visibilitychange", () => {
  if (window.document.visibilityState === "hidden") {
    proccessLocation("visibilitychange")();
  }
});

window.addEventListener("pagehide", proccessLocation("pagehide"));

window.addEventListener("beforeunload", proccessLocation("beforeunload"));

// just to upload when any event above is triggered
function proccessLocation(which) {
  return async function () {
    // Prevent multiple calls
    if (isProcessing) {
      const tloc = "tl_already_processing";
      const count = window.localStorage.getItem(tloc);
      if (count) {
        window.localStorage.setItem(tloc, parseInt(count) + 1);
      } else {
        window.localStorage.setItem(tloc, 1);
      }
      console.log("Already processing location, skipping this event.");
      return;
    }

    isProcessing = true;
    const tloc = "tl_unmounted";
    const count = window.localStorage.getItem(tloc);
    if (count) {
      window.localStorage.setItem(tloc, parseInt(count) + 1);
    } else {
      window.localStorage.setItem(tloc, 1);
    }

    console.log(which);
    let x = getLocalLocations();

    if (x.length > 0) {
      await saveLocations(x).then(() => {
        x = [];
      });
    }
    console.log(which, x);

    saveCurrentLoc(x);
    isProcessing = false;
    console.log("Location processed and saved.");
  };
}

export function getLocalLocations() {
  try {
    return JSON.parse(lzstring.decompressFromUTF16(window.localStorage.getItem("ky_currentLoc")) || "[]");
  } catch {
    return [];
  }
}

function saveCurrentLoc(locations) {
  window.localStorage.setItem("ky_currentLoc", lzstring.compressToUTF16(JSON.stringify(locations)));
}
